
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/myreservation/account",
      function () {
        return require("private-next-pages/myreservation/account.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/myreservation/account"])
      });
    }
  